import React, {useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Form, Select} from 'antd';
import {formHelpers, transactionsHelpers} from '../../../../utils/helpers';
import {expenseTypesConstants} from '../../../../constants';

const defaultExpenseType = expenseTypesConstants.INVOICE;

const TransactionExpenseTypeForm = ({
  dispatch,

  edit,
  expense,
  onSubmit,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [initialFormValues, setInitialFormValues] = useState({
    expense_type: defaultExpenseType
  });

  const expenseTypeOptions = useMemo(() => transactionsHelpers.getExpenseTypeOptions({t}), [t]);

  useEffect(() => {
    const fieldValues = {
      ...initialFormValues,
      expense_type: expense ? expense?.expense_type : defaultExpenseType,
    };
    setInitialFormValues(fieldValues);
    form.setFieldsValue(fieldValues);
  }, [expense]); // eslint-disable-line react-hooks/exhaustive-deps


  const handleSubmit = (data) => {
    if (onSubmit) {
      setLoading(true);
      onSubmit({
        data,
        successCallback: () => setLoading(false),
        errorCallback: (error) => {
          const data = error?.response?.data || {};
          setLoading(false);
          let fields = formHelpers.getFormServerErrorFields(data);
          form.setFields(fields);
        }
      });
    }
  }

  const handleOnSave = () => form.submit();

  return (
    <Form
      initialValues={initialFormValues}
      form={form}
      layout='vertical'
      disabled={loading}
      onFinish={handleSubmit}
      requiredMark={false}
      {...rest}
    >
      <Form.Item
        label={undefined}
        name='expense_type'
        style={{marginBottom: 0}}
      >
        <Select
          onChange={handleOnSave}
          options={expenseTypeOptions}
          size='large'
          variant='borderless'
        />
      </Form.Item>
    </Form>
  );
}

TransactionExpenseTypeForm.propTypes = {
  expense: PropTypes.object,
  onSubmit: PropTypes.func,
}

export default TransactionExpenseTypeForm;
